import React from "react";
import { CheckIcon, LockIcon, ShieldCheckIcon } from "lucide-react";
import { bonuses } from "../data/bonuses";
import { guides } from "../data/guides";
import { CtaButton } from "./CtaButton";
import { PianoKeys } from "./PianoKeys";
import { FormatNotice } from "./FormatNotice";
const GUIDES_VALUE = 67;
export function OfferSection() {
  const bonusValue = bonuses.reduce((sum, b) => sum + b.value, 0);
  const totalValue = GUIDES_VALUE + bonusValue;
  return <section id="offre" className="scroll-mt-12 bg-walnut py-20 md:py-28" aria-labelledby="offer-title" data-id="element-149" data-mp="metkrzt56qy7">
      <div className="mx-auto max-w-6xl px-5" data-id="element-150" data-mp="rdmztwo2uq0h">
        <div className="grid overflow-hidden rounded-3xl bg-linen shadow-[0_40px_80px_-30px_rgba(22,18,15,0.6)] lg:grid-cols-[1.1fr_1fr]" data-id="element-151" data-mp="repsa911t0ii">
          <div className="p-8 md:p-12" data-id="element-152" data-mp="2t5t1ctvai70y">
            <h2 id="offer-title" className="font-display text-4xl uppercase leading-none text-ink md:text-5xl" data-id="element-153" data-mp="2t6uceycb2tio">
              Tout ce que vous recevez aujourd'hui
            </h2>
            <ul className="mt-8 divide-y divide-walnut/10 border-y border-walnut/10" data-id="element-154" data-mp="12pldcy6drlbx">
              {guides.map(g => <li key={g.id} className="flex gap-3 py-4 font-medium text-ink" data-id="element-155" data-mp="sxp36or0s4rc">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-walnut" aria-hidden="true" data-id="element-156" data-mp="svckg9dftqd8" />
                  {g.title}
                </li>)}
              {bonuses.map(b => <li key={b.number} className="flex items-center justify-between gap-4 py-4" data-id="element-157" data-mp="1lk0d4q0ini0t">
                  <span className="flex gap-3 text-stone" data-id="element-158" data-mp="1gl700yp55t16">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-walnut" aria-hidden="true" data-id="element-159" data-mp="1ckmx1ehvzv74" />
                    Bonus {b.number} : {b.title}
                  </span>
                  <span className="shrink-0 text-sm text-stone line-through" data-id="element-160" data-mp="172f58e9q186">{b.value} USD</span>
                </li>)}
            </ul>
            <p className="mt-6 flex justify-between text-stone" data-id="element-161" data-mp="3sbixzxze5nz4">
              <span data-id="element-162" data-mp="3tv14cgqsn77i">Valeur totale</span>
              <span className="line-through" data-id="element-163" data-mp="3trwsqyb0196t">{totalValue} USD</span>
            </p>
          </div>

          <div className="flex flex-col bg-ebony text-center" data-id="element-164" data-mp="2llxjiso72ne">
            <div className="flex flex-1 flex-col items-center justify-center p-8 md:p-12" data-id="element-165" data-mp="3ks9rqdm6m5ea">
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brass" data-id="element-166" data-mp="3ou4yvyqsnczz">
                Paiement unique · Aujourd'hui
              </p>
              <p className="mt-4 flex items-start justify-center font-display text-linen" data-id="element-167" data-mp="3b1orymuruuts">
                <span className="text-[120px] leading-none md:text-[150px]" data-id="element-168" data-mp="3fwb44s8ogrex">27</span>
                <span className="ml-2 mt-4 text-3xl" data-id="element-169" data-mp="31758tfcynlcb">USD</span>
              </p>
              <p className="mt-2 font-serif italic text-sand/80" data-id="element-170" data-mp="3656um81rtyrh">
                au lieu de {totalValue} USD
              </p>
              <CtaButton label="Commander maintenant" variant="brass" className="mt-8 w-full max-w-xs" data-id="element-171" data-mp="2s6qlkagfrw66" />
              <p className="mt-4 flex items-center gap-2 text-xs text-sand/70" data-id="element-172" data-mp="2x5jppc9u2ato">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-173" data-mp="2di73v22as4ze" />
                Paiement sécurisé · PDF reçus immédiatement par e-mail
              </p>
            </div>
            <PianoKeys octaves={2} className="h-10" data-id="element-174" data-mp="2mjoish3yy0mi" />
          </div>
        </div>

        <FormatNotice data-id="element-175" data-mp="2igs3az9q6kms" />

        <div className="mx-auto mt-16 flex max-w-3xl flex-col items-center gap-6 text-center md:flex-row md:text-left" data-id="element-176" data-mp="2ig8hv8kv9e40">
          <div className="flex h-24 w-24 shrink-0 flex-col items-center justify-center rounded-full border-2 border-brass text-brass" data-id="element-177" data-mp="2weq4f2z1ckkc">
            <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-178" data-mp="366clhfy21dv0" />
            <span className="mt-1 font-display text-2xl leading-none" data-id="element-179" data-mp="368p6k1z404ca">10</span>
            <span className="text-[10px] uppercase tracking-widest" data-id="element-180" data-mp="3181c16bo95db">jours</span>
          </div>
          <div data-id="element-181" data-mp="3f7tzmsrwj5h2">
            <h3 className="font-serif text-2xl text-linen" data-id="element-182" data-mp="3f57v720b5632">Garantie satisfait ou remboursé 10 jours</h3>
            <p className="mt-2 leading-relaxed text-sand" data-id="element-183" data-mp="3a64rbkw2d5wo">
              Téléchargez tout, utilisez-le dans vos cours et si en 10 jours vous estimez que ce
              n'est pas pour vous, nous vous remboursons 100 %. Sans questions, sans petites lignes.
            </p>
          </div>
        </div>
      </div>
    </section>;
}